import { render } from "./MainProductsBySupplier.vue?vue&type=template&id=5801ed2e&scoped=true"
import script from "./MainProductsBySupplier.vue?vue&type=script&lang=js"
export * from "./MainProductsBySupplier.vue?vue&type=script&lang=js"

import "./MainProductsBySupplier.vue?vue&type=style&index=0&id=5801ed2e&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5801ed2e"]])

export default __exports__